module.exports = __webpack_public_path__ + "static/media/img08.cbcbd76d.png";